import { combineReducers } from 'redux';
import { getAsyncReducers } from 'react-async-client';

export default () => combineReducers({
    ...getAsyncReducers(),
});
